<template>
  <section class="mosaic-skeleton">
    <PageWrap>
      <SkeletonItem
        class="mosaic-skeleton__title"
        width="min(100%, 600px)"
        height="52px"
        :border-radius="8"
        :is-animated="animated"
        ignore-global-animation
      />
      <SkeletonItem
        class="mosaic-skeleton__change-city"
        width="132px"
        height="32px"
        :border-radius="8"
        :is-animated="animated"
        ignore-global-animation
      />
      <div class="mosaic-skeleton__grid">
        <div
          v-for="n in 8"
          :key="n"
          class="mosaic-skeleton__card"
        >
          <SkeletonItem
            width="100%"
            height="100%"
            :border-radius="16"
            :is-animated="animated"
            ignore-global-animation
          />
        </div>
      </div>
    </PageWrap>
  </section>
</template>

<script setup lang="ts">
  import { SkeletonItem } from '@experience/core-skeleton-lib';

  import PageWrap from '@/shared/ui/PageWrap.vue';

  withDefaults(
    defineProps<{
      animated?: boolean;
    }>(),
    {
      animated: true,
    },
  );
</script>

<style scoped lang="scss">
  .mosaic-skeleton {
    &__change-city {
      display: block;
      margin-top: 16px;
    }

    &__grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 8px;
      margin-top: 48px;

      @include tablet {
        grid-template-columns: repeat(3, 1fr);
      }

      @include mobile {
        grid-template-columns: repeat(2, 1fr);
        margin-top: 40px;
      }
    }

    &__card {
      width: 100%;
      height: 298px;

      @include mobile {
        height: 232px;
      }
    }
  }
</style>
